import { createFileRoute, redirect } from '@tanstack/react-router';

import { SignInPage } from '@/features/auth/SignInPage';

interface SignInSearch {
  redirect?: string;
}

/**
 * Sign-in route. Already-authenticated users are bounced to `/plans` so that
 * the back button doesn't leave them on a sign-in form they no longer need.
 */
export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    redirect:
      typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (context.authStatus === 'authenticated') {
      throw redirect({ to: '/plans' });
    }
  },
  component: SignInPage,
});
